import { render, staticRenderFns } from "./EnabledUseCase.vue?vue&type=template&id=4c2b385d&scoped=true"
import script from "./EnabledUseCase.vue?vue&type=script&lang=js"
export * from "./EnabledUseCase.vue?vue&type=script&lang=js"
import style0 from "./EnabledUseCase.vue?vue&type=style&index=0&id=4c2b385d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2b385d",
  null
  
)

export default component.exports